module.exports = __webpack_public_path__ + "img/rubin_benefit_15_family.368d3f09.svg";